import { createAsyncThunk } from '@reduxjs/toolkit';

import { aflApi } from '../../api/afl-api';
import { changeSeason } from './change-season';
import { getTranslation } from 'common/react/utils/translations';

export const initialiseNav = createAsyncThunk(
    'statspro/initialiseNav',
    async (options = {}, { dispatch }) => {
        const { slice, initialValues, removeFinals } = options;

        let competition = {
            id: initialValues.competitionId || ''
        };

        const season = initialValues.seasonId
            ? {
                  id: initialValues.seasonId
              }
            : null;

        const round = initialValues.roundId
            ? {
                  id: initialValues.roundId
              }
            : null;

        // Set nav ready state to false
        dispatch({ type: `statspro/${slice}/setReady`, payload: false });

        const { data: compData } = await dispatch(
            aflApi.endpoints.getCompetitions.initiate()
        );

        const foundComp = compData.find(
            (item) => item.id === parseInt(competition.id)
        );

        // Set 'competition' nav item in the state
        dispatch({
            type: `statspro/${slice}/setNavItem`,
            payload: {
                navItem: 'competition',
                value: foundComp || competition
            }
        });

        // Get comp seasons for the selected competition
        const { data: seasons } = await dispatch(
            aflApi.endpoints.getCompSeasons.initiate({
                competitionId: foundComp ? foundComp.id : competition.id
            })
        );

        // Set 'seasons' nav item in the state
        dispatch({
            type: `statspro/${slice}/setNavItem`,
            payload: { navItem: 'seasons', value: seasons }
        });

        // Get & set selected season
        let selectedSeason;

        // If career
        if (season.id === -1) {
            selectedSeason = {
                id: -1,
                name: getTranslation('label.stats.career')
            };
        } else {
            selectedSeason =
                seasons.find((item) => item.id === parseInt(season?.id)) ||
                seasons[0];
        }

        // Dispatch change season thunk
        await dispatch(
            changeSeason({
                slice,
                season: selectedSeason,
                round,
                removeFinals
            })
        );

        // Set initial filter values
        Object.keys(initialValues.filters || {}).forEach((filterKey) => {
            const value = initialValues.filters[filterKey];
            dispatch({
                type: `statspro/${slice}/setFilterItem`,
                payload: { filterItem: filterKey, value }
            });
        });

        /**
         * Set other initial params if they exist
         */

        const initialParams = initialValues.initialParams || {};

        if (initialParams.category) {
            dispatch({
                type: `statspro/${slice}/setNavItem`,
                payload: {
                    navItem: 'category',
                    value: initialParams.category
                }
            });
        }

        if (initialParams.sortColumn || initialParams.sortDirection) {
            dispatch({
                type: `statspro/${slice}/setSort`,
                payload: {
                    columnId: initialParams.sortColumn,
                    sortDirection: initialParams.sortDirection,
                    force: false
                }
            });
        }

        if (initialParams.dataType) {
            dispatch({
                type: `statspro/${slice}/setDataType`,
                payload: {
                    type: initialParams.dataType
                }
            });
        }

        if (initialParams.benchmarking) {
            dispatch({
                type: `statspro/${slice}/setBenchmarking`,
                payload: {
                    isActive:
                        initialParams.benchmarking === 'true' ? true : false
                }
            });
        }
    }
);
